module.exports = __webpack_public_path__ + "static/media/nbtn_2x.a74549bb.png";